export var allDocumentTypeInfo = {hasGottenInfo: false};